import React, { useContext, useEffect, useState } from 'react'
import CenterModal from '../../../components/Modals/center-modal'
import { ReactComponent as CloseIcon } from '../../../assets/close.svg';
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg';
import InputText from '../../../components/InputGroup/InputText';
import MobileInput from '../../../components/InputGroup/MobileInput';
import InputSelect from '../../../components/InputGroup/InputSelect';
import InputTextarea from '../../../components/InputGroup/InputTextarea';
import DateTimePicker from '../../../components/InputGroup/DateTime';
import { insert, scheduleSiteVisit } from '../../../services/private/plus.leads.service';
import { getProjects } from '../../../services/private/company.service';
import { toast } from 'react-toastify';
import { getUpcomingSvByBrokerId } from '../../../services/public/public.service';
import { sv } from 'date-fns/locale';

const ScheduleSiteVisitModal = ({ show, closeModal, uuid, handleGetLeads, redirectFrom, selectedLead, userProfile, users }) => {
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [project, setProjects] = useState([]);
    const [scheduleDate, setScheduleDate] = useState('');
    const [type, setType] = useState('onsite');
    const [commnets, setComments] = useState('');
    const [projectList, setProjectList] = useState([])
    const [error, setError] = useState('');
    const [assignedTo, setAssignedTo] = useState('');

    useEffect(() => {
        if (selectedLead && Object.keys(selectedLead)?.length > 0) {
            setName(selectedLead?.customer_name || '');
            setMobile(selectedLead?.customer_mobile || '');
        }
    }, [selectedLead]);


    useEffect(() => {
        if (users?.length) {
            const owner = users.find(i => i.is_owner)
            setAssignedTo(owner)
        }
    }, [users])
    const getAllProjects = async () => {

        await getProjects({}, '').then((res) => {
            if (res.status === 200) {
                let projects = res.data.data.map(i => ({ ...i, label: i.name, value: i.uuid }));
                setProjectList(projects.filter(item => !selectedLead?.site_visits.some(sv => sv?.project_name === item?.label)))
            }
        }).catch((err) => {
            console.log("Something went wrong", err);
        })
    }

    useEffect(() => {
        if (uuid && projectList?.length) {
            const filteredProject = projectList.filter(i => i.value === uuid);
            setProjects(filteredProject);
        }
    }, [uuid, projectList]);

    useEffect(() => {
        getAllProjects()
    }, []);

    const handleSubmit = async () => {
        if (!name || !mobile || !scheduleDate || !type || (mobile.length < 10 && !project.includes("Le Marque"))) {
            setError(true);
            return;
        } else {
            setError(false)
        }

        const payload = {
            customer_name: name,
            customer_mobile: mobile,
            customer_email: '',
            projects: project.map(i => ({
                projectUuid: i.value,
                schedule_date: scheduleDate,
                sv_type: type,
                remarks: commnets,
                assigned_to: assignedTo?.value || null
            })), //need to discuss this with ankit

        }

        // const res = await insert(payload);
        const res = await scheduleSiteVisit(payload)
        if (res.data.status === 200) {
            console.log(res.data.message);
            // toast.success(res.data.message);
            toast.success('Site visit scheduled')
            if (!redirectFrom) {
                handleGetLeads();
            }
            closeModal();
        }
    }

    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!w-[560px]  [&>*]:!border-0 [&>*]:!rounded-xl [&>*]:!overflow-hidden'>
            <div className='!p-6'>
                <div className={`d-flex align-items-center justify-content-between`}>
                    {/* <h2 className='fz18 black fw-po-medium mb-0 inter'>Project Added to your list</h2> */}
                    <div className='h-12 w-12 rounded-xl bg-[#684EFB1A]/10 flex items-center justify-center'>
                        <LocationIcon className=' fill-blue-900 h-12 w-12' />
                    </div>
                    <button onClick={closeModal} className='border-0 bg-tr'><CloseIcon /></button>
                </div>
                <div className='!mt-4'>
                    <h1 className='m-0 text-lg font-semibold'>Schedule a Site Visit</h1>
                </div>
                <div className='grid grid-cols-2 !gap-2'>
                    <div className='col-span-2'>
                        <InputText
                            label={'Name'}
                            placeholder={'e.g. Rahul'}
                            inputclass={'!mb-0'}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            error={error && !name ? 'Please Enter Name' : ''}
                            required={true}
                        />
                    </div>
                    <MobileInput
                        label='Mobile'
                        value={mobile}
                        onChange={(e) => setMobile(e.phone)}
                        error={error}
                        // disable={userMobile ? true : false}
                        inputclass='!h-10 !w-full !mb-0'
                        required={true}
                    />
                    <InputSelect
                        label={'Projects'}
                        value={project} // Array of selected projects
                        onChange={(value) => setProjects(value)} // Update selected projects
                        error={(error && project?.length === 0) ? 'Please Select Project' : ''}
                        options={projectList} // Exclude selected projects
                        isMulti={true} // Enable multiple selection
                        required={true}
                    />
                    <div className='col-span-2'>
                        {/* <label>Type of Site Visit</label> */}
                        <div className='flex gap-6'>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${type === 'onsite' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setType('onsite')}
                            >
                                <input
                                    type="radio"
                                    name="invest"
                                    id=""
                                    className='accent-white'
                                    value={type}
                                    checked={type === 'onsite'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Onsite</label>
                            </div>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${type === 'video call' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setType('video call')}
                            >
                                <input
                                    type="radio"
                                    name="invest"
                                    id=""
                                    className='accent-white'
                                    value={type}
                                    checked={type === 'video call'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Video Call</label>
                            </div>
                            {/* <label className='mr-4'>
                                <input
                                    type='radio'
                                    name='sitevisit'
                                    value={type}
                                    checked={type === 'onsite'}
                                    onChange={() => setType('onsite')}
                                /> Onsite
                            </label>
                            <label>
                                <input
                                    type='radio'
                                    name='sitevisit'
                                    value={type}
                                    checked={type === 'video call'}
                                    onChange={() => setType('video call')}
                                /> Video Call
                            </label> */}
                        </div>

                        {/* {(error && !type) &&
                            <div className='invalide'>
                                <div className="input-feedback mt-8">
                                    Please Select Site visit Type
                                </div>
                            </div>
                        } */}
                    </div>
                    <div className='col-span-2'>
                        <DateTimePicker
                            label={'Sitevisit Date & Time'}
                            inputclass={'!mb-0'}
                            value={scheduleDate}
                            onValueChange={(date) => {
                                setScheduleDate(date)
                            }}
                            error={(error && !scheduleDate) ? 'Please Select Sitevisit Date & Time' : ''}
                            required={true}
                        />
                    </div>
                    {userProfile?.is_owner && <div className='col-span-2'>
                        <InputSelect
                            label={'Assigned To'}
                            value={assignedTo}
                            onChange={(value) => setAssignedTo(value)}
                            // error={(error && project.length === 0) ? 'Please Select Project' : ''}
                            options={users}
                            isMulti={false}
                            required={false}
                        />
                    </div>}
                    <div className='col-span-2'>
                        <InputTextarea
                            label={'Comments'}
                            placeholder={'Add comments'}
                            inputclass={'!mb-0'}
                            value={commnets}
                            onChange={(e) => setComments(e.target.value)}
                        />
                    </div>

                </div>
                <div className='w-full flex !gap-4 !mt-4'>
                    <button className='w-1/2 border py-2 text-black700 rounded-lg' onClick={closeModal}>Cancel</button>
                    <button
                        className='w-1/2 gradient-blue text-white py-2 rounded-lg font-medium'
                        onClick={handleSubmit}
                    >Schedule Site Visit</button>

                </div>
            </div>
        </CenterModal>
    )
}

export default ScheduleSiteVisitModal